import { call, put } from 'redux-saga/effects';
import { get } from 'lodash';
import userDux from 'src/redux/user/';
import EventNames from 'src/lib/eventNames';
import trackingDux from 'src/redux/tracking';
import ViewerApi from 'src/apis/viewer';
import env from 'src/env';
import Braze from 'src/services/brazeService';

/*
 * @param {string} baseUrl - e.g. https://hover.to or https://staging.hover.to
 */
const redirectToLoginPage = (baseUrl) => {
  window.location.replace(
    `${baseUrl}/login/?redirect_to=${encodeURIComponent(window.location.href)}`,
  );
};

/*
 * Check if the user has a valid token.
 * If not, redirect to the login page.
 */
function* checkAuthSaga() {
  try {
    const res = yield call([ViewerApi, ViewerApi.getUserProfile]);
    const userProfile = get(res, 'data.user');
    yield put(userDux.actions.setUserProfile(userProfile));
    Braze.initializeUserSession(userProfile);
  } catch (e) {
    yield put(
      trackingDux.actions.track(EventNames.viewer.USER_NOT_AUTHENTICATED),
    );
    yield call(redirectToLoginPage, env.LOG_IN_URL);
  }
}

export default {
  checkAuthSaga,
  redirectToLoginPage,
};
